import React, { PureComponent } from 'react';

import Svg, { Path } from '@dbk/ui-svg';

const dbLogo = 'M0 30.078h30.22V0H0v30.078zm4.228-4.212H25.99V4.21H4.228v21.656zM18.132 ' +
  '7.218L6.646 22.858h5.442l11.486-15.64h-5.442z';


class DBLogo extends PureComponent {
  render() {
    return (
      <div className="dblogocss">
        <Svg width="30" height="30">
          <Path d={dbLogo} fill="#fff" fillRule="evenodd"/>
        </Svg>
      </div>
    );
  }
}

export default DBLogo
